import { useEffect, useRef } from 'react';
import { useState } from 'react';
import { motion } from 'framer-motion';
import { FaPhoneAlt, FaEnvelope, FaMapMarkerAlt } from 'react-icons/fa';
import { Lightbulb, Unlock, TicketCheck } from "lucide-react";



export default function Careers() {
    const [step, setStep] = useState('initial');
  const [selectedOption, setSelectedOption] = useState('');


  const videoRef = useRef(null);
  const [isPlaying, setIsPlaying] = useState(false);
  const [hasEnded, setHasEnded] = useState(false);

  const handleVideoClick = () => {
    const video = videoRef.current;

    if (hasEnded) {
      video.currentTime = 0;
      video.play();
      setIsPlaying(true);
      setHasEnded(false);
    } else if (isPlaying) {
      video.pause();
      setIsPlaying(false);
    } else {
      video.play();
      setIsPlaying(true);
    }
  };

  const handleEnded = () => {
    setIsPlaying(false);
    setHasEnded(true);
  };







  
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);


 
  return (
    <div className="bg-slate-900">
  {/* Hero Section */}
  <div className="relative md:h-[70vh] h-[40vh] overflow-hidden">
    {/* Background Image with Zoom Out */}
    <motion.div
      initial={{ scale: 1.2 }}
      animate={{ scale: 1 }}
      transition={{ duration: 3, ease: "easeOut" }}
      className="absolute inset-0 bg-cover bg-center"
      style={{ backgroundImage: "url('/assets/images/careers-section-img.png')" }}
    />

    {/* Overlay */}
    <div className="absolute inset-0 bg-black bg-opacity-30" />

    {/* Heading on the Left */}
    <div className="relative z-10 h-full flex items-end sm:items-center justify-start px-5 sm:px-10 pb-10 sm:pb-0">
      <motion.h1
        initial={{ opacity: 0, y: 80 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 2, ease: "easeOut" }}
        className="text-white text-5xl sm:text-4xl md:text-7xl font-semibold bg-black bg-opacity-40 px-4 py-3 sm:px-6 sm:py-6 rounded-xl shadow-xl max-w-[90%] sm:max-w-[70%]"
      >
        Careers
      </motion.h1>
    </div>
  </div>


  <div className=" text-white relative">
    { /* Background Video */}
      <video autoPlay muted loop playsInline className="absolute inset-0 w-full h-full object-cover z-0">
        <source src="/assets/videos/investor-rise-bg-map.mp4" type="video/mp4" />
        Your browser does not support the video tag.
      </video>
      <div className="absolute inset-0 bg-black bg-opacity-35 z-0" />

      <div className="relative z-10">
        {/* About Us Description */}
    <div className="px-5 sm:px-10 py-10 max-w-7xl mx-auto text-left">
      <motion.p
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 1.5, delay: 0.3 }}
        className="text-lg sm:text-xl text-white"
      >
       We’re shaping the future of real estate — starting now.<br/>

At Investor<span className='text-teal-500 font-medium'>Rise</span>, we believe everyone deserves a smarter, more accessible way to invest in real estate. That’s why we’re driven every day to turn that vision into reality for thousands of investors.<br/>

Here, every team member has the chance to make a real impact — on the company and on their own career. Hard work is always recognized and rewarded.<br/>

Join our dynamic, diverse, and forward-thinking team.
      </motion.p>
    </div>

    {/* Video Section */}
  

    <div className="flex flex-col items-center justify-center px-5 sm:px-10 py-16 max-w-7xl mx-auto gap-10">
      <motion.div
        initial={{ opacity: 0, scale: 1.05 }}
        whileInView={{ opacity: 1, scale: 1 }}
        transition={{ duration: 2.2, delay: 0.7, ease: "easeOut" }}
        className="relative w-full max-w-4xl"
      >
        <div className="relative  overflow-hidden shadow-2xl group">
          <video
            ref={videoRef}
            src="/assets/videos/careers-section-video.mp4"
            className="w-full h-[350px] sm:h-[400px] md:h-[500px] object-cover  bg-black"
            muted
            onEnded={handleEnded}
          />

          {/* Overlay Play/Pause/Replay Button */}
          <button
            onClick={handleVideoClick}
            className={`absolute inset-0 flex items-center justify-center transition duration-300 
              ${!isPlaying ? "bg-black bg-opacity-40 hover:bg-opacity-60" : "bg-transparent"}`}
          >
            {!isPlaying && (
              <div className="bg-white p-4 rounded-full shadow-lg hover:scale-110 transition-transform duration-300">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-8 w-8 text-teal-500"
                  fill="currentColor"
                  viewBox="0 0 24 24"
                >
                  {hasEnded ? (
                    // Replay Icon
                    <path d="M12 5v4l4-4-4-4v3a7 7 0 1 0 7 7h-2a5 5 0 1 1-5-5z" />
                  ) : (
                    // Play Icon
                    <path d="M8 5v14l11-7z" />
                  )}
                </svg>
              </div>
            )}
          </button>
        </div>

        {/* Decorative Animated Frames with Opacity */}
        <motion.div
          animate={{ y: [0, -18, 5, 0] }}
          transition={{ repeat: Infinity, duration: 3 }}
          className="absolute top-[-20px] left-[-20px] w-[60px] h-[160px] border-t-[22px] border-l-[22px] border-teal-400 opacity-30 "
        ></motion.div>
        <motion.div
          animate={{ y: [0, 18, -5, 0] }}
          transition={{ repeat: Infinity, duration: 3 }}
          className="absolute bottom-[-20px] right-[-20px] w-[60px] h-[160px] border-b-[22px] border-r-[22px] border-teal-400 "
        ></motion.div>
      </motion.div>
    </div>



       {/* Reversed Section With Image On Left */}
       <div className="flex flex-col items-center justify-center px-5 sm:px-10 py-16 max-w-4xl mx-auto text-center">
  {/* Text Content */}
  <motion.div
    initial={{ opacity: 0, y: 30 }}
    whileInView={{ opacity: 1, y: 0 }}
    transition={{ duration: 2.2, delay: 0.5 }}
    className="w-full"
  >
    <h2 className="text-3xl sm:text-4xl font-bold mb-4 text-teal-400">Real Estate Careers</h2>
    <p className="text-white text-base sm:text-lg leading-relaxed mb-6">
    Looking to take the next step in your career? We provide the tools, coaching, and resources needed for you to be successful. Get ready for our sophisticated operation with leaders that genuinely care about your success and wellbeing. Our goal is to maximize your potential and help you deliver. Be a force to be reckoned with. Be a leader. Achieve your best life and fulfill your personal why and our collective mission.
    </p>
    <button className="relative overflow-hidden py-3 px-8 text-white font-semibold bg-teal-500 shadow-xl text-lg group">
      <span className="absolute inset-0 bg-gradient-to-r from-slate-900 to-slate-900 group-hover:from-slate-900 group-hover:to-slate-900 animate-slide-bg transition-all duration-500 ease-in-out"></span>
      <span className="relative z-10">Discover More</span>
    </button>
  </motion.div>
</div>


  </div>

</div>

<div className="bg-white">



<div className="relative py-32 px-5 sm:px-10 bg-gray-900 text-white overflow-hidden">
      {/* Animated Large Faded Heading in Background */}
      <motion.h1
  initial={{ opacity: 0, x: 200 }} // Start off to the right
  whileInView={{ opacity: 0.1, x: 0 }} // Move to original position
  transition={{ duration: 1.5, ease: "easeOut" }}
  className="absolute top-16 left-1/3 transform -translate-x-1/2 text-8xl sm:text-[10rem] md:text-[12rem] font-extrabold text-white z-0 select-none whitespace-nowrap pointer-events-none"
>
  Core Values
</motion.h1>


      {/* Section Content */}
     
      <div className="relative z-10 max-w-7xl mx-auto mt-40">
  <div className="grid grid-cols-1 md:grid-cols-3 gap-10">
    {/* Card 1 */}
    <motion.div
      initial={{ opacity: 0, y: 30 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{ duration: 1, delay: 0.2 }}
      className="bg-gray-800 p-8 rounded-2xl shadow-2xl text-center group hover:scale-105 transition-transform duration-300"
    >
      <div className="mb-6 transition-transform duration-300 group-hover:scale-125 group-hover:drop-shadow-[0_0_12px_#14b8a6]">
        <Lightbulb className="w-16 h-16 mx-auto text-teal-400" />
      </div>
      <h3 className="text-2xl font-semibold">Be Authentic</h3>
    </motion.div>

    {/* Card 2 */}
    <motion.div
      initial={{ opacity: 0, y: 30 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{ duration: 1, delay: 0.4 }}
      className="bg-gray-800 p-8 rounded-2xl shadow-2xl text-center group hover:scale-105 transition-transform duration-300"
    >
      <div className="mb-6 transition-transform duration-300 group-hover:scale-125 group-hover:drop-shadow-[0_0_12px_#14b8a6]">
        <Unlock className="w-16 h-16 mx-auto text-teal-400" />
      </div>
      <h3 className="text-2xl font-semibold">Unlock Potential</h3>
    </motion.div>

    {/* Card 3 */}
    <motion.div
      initial={{ opacity: 0, y: 30 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{ duration: 1, delay: 0.6 }}
      className="bg-gray-800 p-8 rounded-2xl shadow-2xl text-center group hover:scale-105 transition-transform duration-300"
    >
      <div className="mb-6 transition-transform duration-300 group-hover:scale-125 group-hover:drop-shadow-[0_0_12px_#14b8a6]">
        <TicketCheck className="w-16 h-16 mx-auto text-teal-400" />
      </div>
      <h3 className="text-2xl font-semibold">Deliver Results</h3>
    </motion.div>
  </div>

  {/* Description below the cards */}
  <motion.div
    initial={{ opacity: 0, y: 30 }}
    whileInView={{ opacity: 1, y: 0 }}
    transition={{ duration: 2.2, delay: 0.5 }}
    className="w-full"
  >
  <div className="mt-10 text-center text-white sm:text-lg max-w-3xl mx-auto px-4">
    <p>There are three fundamental values we hold ourselves to every day—principles that drive our team forward in pursuit of success we take pride in. These aren’t empty buzzwords, either. They are the standards we judge ourselves against. They influence not only our decisions but our actions.</p>
    
  </div>
  </motion.div>
</div>







    </div>








{/* Info Section */}
<div className="flex flex-col md:flex-row items-center justify-between px-5 sm:px-10 py-16 max-w-7xl mx-auto gap-10">
  {/* Text Content */}
  <motion.div
    initial={{ opacity: 0, x: -50 }}
    whileInView={{ opacity: 1, x: 0 }}
    transition={{ duration: 2.2, delay: 0.7 }}
    className="w-full md:w-1/2"
  >
    <h2 className="text-3xl sm:text-4xl font-bold mb-4 text-slate-900">Company Culture
    </h2>
    <p className="text-black text-base sm:text-lg leading-relaxed">
    At Investor<span className='text-teal-500 font-medium'>Rise</span>, our culture is the cornerstone of everything we do—it’s always been our top priority. That’s why we continuously invest in it and work hard to preserve it. We’re guided by three core values: “Deliver Results,” “Unlock Potential,” and “Be Authentic.”<br/>

Our leadership team is deeply committed to supporting every team member's growth—both professionally and personally. We offer one-on-one mentorship covering a wide range of topics, from learning how to invest the right way to setting and achieving career and personal goals. You'll also gain access to valuable resources that empower you to thrive and grow into the most authentic, successful version of yourself.<br/>

If that sounds like your kind of environment—plus we offer quarterly team outings, weekly catered lunches, exciting investment opportunities, and sales bonuses—then InvestorRise could be the perfect place for you. We're proud to be a company where people genuinely look forward to coming to work every day.<br/>
    </p>
    <button className="relative overflow-hidden py-3 px-8 mt-4 text-white font-semibold bg-teal-500 shadow-xl text-lg group">
      <span className="absolute inset-0 bg-gradient-to-r from-slate-900 to-slate-900 group-hover:from-slate-900 group-hover:to-slate-900 animate-slide-bg transition-all duration-500 ease-in-out"></span>
      <span className="relative z-10">Learn More</span>
    </button>
  </motion.div>

  {/* Image Content */}
  <motion.div
  initial={{ opacity: 0, scale: 1.1 }}
  whileInView={{ opacity: 1, scale: 1 }}
  transition={{ duration: 1.2, ease: "easeInOut", delay: 0.6 }}
  className="w-full md:w-1/2 relative group perspective"
>
  <div className="relative overflow-hidden shadow-lg ">
    <img
      src="/assets/images/careers-section-img-2.png"
      alt="About Us"
      className="w-full h-full object-cover transform transition-transform group-hover:scale-105 duration-1000"
      
    />
  </div>
</motion.div>

</div>






    
 <div className="relative w-full overflow-hidden">
  {/* Background Video */}
  <video
    className="absolute top-0 left-0 w-full h-full object-cover z-[0]"
    autoPlay
    muted
    loop
    playsInline
  >
     <source src="/assets/videos/investor-rise-bg-map.mp4" type="video/mp4" />
    Your browser does not support the video tag.
  </video>
  <div className="absolute inset-0 bg-black bg-opacity-35 z-0" />

  {/* Foreground Content */}
  <div className="flex flex-col md:flex-row-reverse items-center justify-between px-5 sm:px-10 py-16 max-w-7xl mx-auto gap-10">
    {/* Text Content */}
    <motion.div
  initial={{ opacity: 0, x: 50 }}
  whileInView={{ opacity: 1, x: 0 }}
  viewport={{ once: true }}
  transition={{ duration: 2.2, delay: 0.5 }}
  className="md:w-1/2 z-[10]" // <-- z-index added
>
      <h2 className="text-3xl sm:text-4xl font-bold mb-4 text-teal-500">
        To provide personal and financial growth for all our partners.
      </h2>
      <p className="text-white text-base sm:text-lg leading-relaxed">
        Our mission statement is the core of our business. It is more than words on a page. It permeates everything we do, and it reinforces why we work so hard.
      </p>
      <button className="relative overflow-hidden py-3 px-8 mt-4 text-white font-semibold  bg-teal-500 shadow-xl text-lg group">
        <span className="absolute inset-0 bg-gradient-to-r from-slate-900 to-slate-900 group-hover:from-tslate-900 group-hover:to-slate-900 animate-slide-bg transition-all duration-500 ease-in-out"></span>
        <span className="relative z-10">Discover More</span>
      </button>
    </motion.div>

    {/* Image Content */}
    <motion.div
      initial={{ opacity: 0, scale: 1.1 }}
      whileInView={{ opacity: 1, scale: 1 }}
      transition={{ duration: 2.4, delay: 0.6, ease: "easeOut" }}
      className="md:w-1/2 relative group"
    >
      <div className="relative">
        <div className="overflow-hidden shadow-2xl">
          <img
            src="/assets/images/careers-section-img-3.png"
            alt="What We Do"
            className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
          />
        </div>

        {/* Animated Decorative Frame */}
        <motion.div
          animate={{ y: [0, -18, 5, 0] }}
          transition={{ repeat: Infinity, duration: 3 }}
          className="absolute top-[-20px] left-[-20px] w-[60px] h-[160px] border-t-[22px] border-l-[22px] border-teal-500 "
        ></motion.div>
        <motion.div
          animate={{ y: [0, 18, -5, 0] }}
          transition={{ repeat: Infinity, duration: 3 }}
          className="absolute bottom-[-20px] right-[-20px] w-[60px] h-[160px] border-b-[22px] border-r-[22px] border-teal-500 "
        ></motion.div>
      </div>
    </motion.div>
  </div>
</div>


</div>





</div>

  
  );
}
